import { RootState } from 'store';

export function createFeatureSelector<T extends keyof RootState['app']>(featureName: T) {
  return (state: RootState) => state.app[featureName];
}
